<script>
  import { useClickOutside } from '$lib/utils/useClickOutside';
  import { fade } from 'svelte/transition';
  import Icon from './Icon.svelte';

  let {
    expandDown = false,
    onconfirm = undefined,
    oncancel = undefined,
  } = $props();
</script>

<div
  transition:fade={{ duration: 100 }}
  use:useClickOutside
  onclickOutside={() => oncancel?.()}
  class="relative -translate-y-1 rounded-sm border border-gray-8 bg-gray-9 p-2 shadow-md"
>
  {#if expandDown}
    <div
      class="absolute left-1/2 top-2 h-4 w-4 -translate-x-1/2 -translate-y-full -rotate-45 border-r border-t border-gray-8 bg-gray-9"
    ></div>
  {:else}
    <div
      class="absolute bottom-2 left-1/2 h-4 w-4 -translate-x-1/2 translate-y-full -rotate-45 border-b border-l border-gray-8 bg-gray-9"
    ></div>
  {/if}

  <div class="relative flex gap-2">
    <button
      class="flex rounded-sm bg-red p-1 px-1 text-sm text-white transition hover:opacity-80"
      onclick={(event) => {
        event.preventDefault();
        onconfirm?.();
      }}
    >
      <Icon icon="delete" size="md" />
      <div>Bekräfta</div>
    </button>
    <button
      class="flex rounded-sm p-1 px-1 text-sm text-gray-3 transition hover:text-white"
      onclick={() => oncancel?.()}
    >
      <div>Avbryt</div>
    </button>
  </div>
</div>
